import * as h2Api from '../h2Api'

export const ACKNOWLEDGEMENT_REQ = 'TUTORIAL_ACKNOWLEDGEMENT_REQ'

export const ACKNOWLEDGEMENT_LOADED = 'TUTORIAL_ACKNOWLEDGEMENT_LOADED'
export const ACKNOWLEDGEMENT_GRANTED = 'TUTORIAL_ACKNOWLEDGEMENT_GRANTED'

export const ADMIN_USER_TUTORIAL_1 = 'admin_tutorial_1'
export const ADMIN_LESSON_TUTORIAL_1 = 'admin_lesson_tutorial_1'
export const MINIHUB_TUTORIAL_1 = 'mini_career_hub_1'
export const ADMIN_LOCAL_OPPS_TUTORIAL_1 = 'admin_local_opps_tutorial_1'
export const LESSON_ASSIGNMENT_TUTORIAL_1 = 'lesson_assignment_tutorial_1'

export const LOAD_HOME_TUTORIAL = 'LOAD_HOME_TUTORIAL'

export const loadAcknowledgement = acknowledgementId => dispatch => {
  return dispatch(
    h2Api.get(`/user/acknowledge/${acknowledgementId}`)({
      type: ACKNOWLEDGEMENT_REQ
    })
  ).then(p => {
    dispatch({ type: ACKNOWLEDGEMENT_LOADED, key: acknowledgementId, details: p })

    return p
  })
}

export const acknowledgeTutorial = acknowledgementId => dispatch => {
  return dispatch(
    h2Api.put(`/user/acknowledge/${acknowledgementId}`)({
      type: ACKNOWLEDGEMENT_GRANTED
    })
  )
}
